import { ComponentType } from 'preact'
import { YogaWidgetBase, InitData } from '../../core'
import { NewsletterWidget } from './NewsletterWidget'

class HoldstyringNewsletterElement extends YogaWidgetBase {
  protected getComponent(): ComponentType<{ initData: InitData }> {
    return NewsletterWidget
  }

  // Supported HTML attributes:
  //   title="..."        — heading inside the card (default: "Tilmeld nyhedsbrev")
  //   subtitle="..."     — description text (default: standard Danish copy)
  //   button-text="..."  — submit button label (default: "Tilmeld")
  protected getWidgetProps() {
    return {
      title: this.getAttribute('title') || null,
      subtitle: this.getAttribute('subtitle') || null,
      buttonText: this.getAttribute('button-text') || null,
    }
  }
}

if (!customElements.get('holdstyring-newsletter')) {
  customElements.define('holdstyring-newsletter', HoldstyringNewsletterElement)
}

export { HoldstyringNewsletterElement }
